import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { PriceButton } from '../HelperComponents/StyledComponents';

export class Song extends Component {
  static propTypes = {
    numeration: PropTypes.number,
    name: PropTypes.string,
    artist: PropTypes.string,
    genre: PropTypes.string,
    price: PropTypes.number,
    album: PropTypes.string,
    tempo: PropTypes.string
  };
  
  render() {
    return (
      <Fragment>
        <section className="columns is-vcentered has-text-white song">
          <section className="column is-narrow">
            <p className="is-size-2">{this.props.numeration+1}</p>
          </section>
          <section className="column">
            <p>{this.props.name}</p>
            <p>{this.props.artist}</p>
            <small>{this.props.genre}</small>
          </section>
          <section className="column has-text-right">
            <PriceButton theme={{backgroundColor: '#101216', color: '#FFFFFF'}}>${this.props.price}</PriceButton>
          </section>
        </section>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Song/Song.js